// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ChatBubbleSquareIconSignature {
  Element: SVGSVGElement;
}

export const ChatBubbleSquareIcon: TOC<ChatBubbleSquareIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.99799 18V22L11.331 18H19.998C21.101 18 21.998 17.103 21.998 16V4C21.998 2.896 21.101 2 19.998 2H3.99799C2.89499 2 1.99799 2.896 1.99799 4V16C1.99799 17.103 2.89499 18 3.99799 18H5.99799ZM3.99799 16V4H19.998V16H10.665L7.99799 18V16H3.99799Z"/>
</svg>
</template>;